<template>
  <div class="activistyMaterial">
    <div class="common_group">
      <div class="title">
        <img src="@/assets/images/toolKitIcon.png">
        <span>{{ $t('newApp.activityInfo.tas') }}</span>
      </div>
      <ul class="toolKit">
        <li>
          <div class="private">
            <img src="@/assets/images/toolKitIconfont.png">
            <span>{{ reportType=== '1' ? RegionalReporting.activityName : toolkit.activityName }}</span>
          </div>
          <el-button type="primary" @click="toolKitDownload(reportType=== '1' ? RegionalReporting : toolkit)">
            <i class="iconfont icon-xiazai-Icon" />
            {{ $t('general.Download') }}
          </el-button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { activityQueryDetails } from '../../service';
export default {
  data () {
    return {
      RegionalReporting: {
        activityName: '',
        activityToolkit: ''
      }
    };
  },
  props: {
    toolkit: {
      type: Object,
      default: () => {
        return {};
      }
    },
    reportType: {
      type: String,
      default: ''
    },
    activityCode: {
      type: String,
      default: ''
    }
  },
  methods: {
    toolKitDownload (val) {
      let link = val.activityToolkit;
      if (link) {
        // 解决直接写入变量路径，vue会进行路径拼接问题。
        if (link.indexOf('https') > -1) {
          let href = link.replace('https://', '');
          window.open('https://' + href);
        } else {
          let href = link.replace('http://', '');
          window.open('http://' + href);
        }
      }
    }
  },
  mounted () {
    this.reportType === '1' && activityQueryDetails.getToolKitData(this.activityCode).then(res => {
      if (res.status === '200') {
        console.log(res.data);
        const { sourceName, sourceLink } = res.data;
        this.RegionalReporting = {
          activityName: sourceName,
          activityToolkit: sourceLink
        };
      }
    });
  }
};
</script>

<style lang="scss" scoped>
@import "@/style/common";
.activistyMaterial{
  .toolKit{
    >li{
      background: #FCFDFE;
      padding: 12px 22px;
      @extend .clear;
      &.stripe{
        background: #F3F5F8;
      }
      >.private{
        float: left;
        height: 30px;
        line-height: 30px;
        >img{
          vertical-align: middle;
          margin-right: 10px;
        }
        >span{
          display: inline-block;
          vertical-align: middle;
        }
      }
      >.el-button{
        float: right;
        padding: 7px 14px!important;
        >span>i{
          font-size: 12px;
        }
      }
    }
  }
  >.QRcode{
    >.content{
      >div{
        width: 160px;
        float: left;
        &~div{
          margin-left: 50px;
        }
        >.image{
          width: 100%;
          height: 160px;
          background: #DCDFE6;
          margin-bottom: 16px;
          >img{
            width: 100%;
          }
        }
      }
    }
  }
  .iframe-wrap{
    height: 900px;
  }
}
</style>
